import React from 'react';
import { Modal, Field } from '../../components/ui';
import { RATE_TYPES, SERVICE_STATUSES, OTHER_SERVICE_TYPE, isPerUnit } from './useServices';

// Desktop add/edit service dialog — two columns, money on one line.
export default function ServiceFormDesktop({ vm }) {
  const {
    form, setF, editing, saving, save, setOpen, typeOptions, functionOptions, userOptions,
    vendorMode, setVendorMode, selectedType,
  } = vm;
  const perUnit = isPerUnit(form.RateType);
  const unitWord = form.RateType === 'PerPlate' ? 'Plates confirmed' : form.RateType === 'PerDay' ? 'Days' : form.RateType === 'PerHour' ? 'Hours' : 'Quantity';

  return (
    <Modal
      wide dense
      title={editing ? `Edit ${editing.ServiceType}` : 'Add Service'}
      onClose={() => setOpen(false)}
      footer={<>
        <button className="btn light" onClick={() => setOpen(false)}>Cancel</button>
        <button className="btn primary" disabled={saving} onClick={save}>{saving ? 'Saving...' : 'Save'}</button>
      </>}
    >
      <div className="form-grid cols-4">
        <div className="span-2">
          <Field label="Service" type="select" value={form.ServiceTypeId} options={typeOptions} required
            onChange={(v) => setF('ServiceTypeId', v)} />
        </div>
        {form.ServiceTypeId === OTHER_SERVICE_TYPE && (
          <div className="span-2">
            <Field label="New service name" value={form.ServiceType} required onChange={(v) => setF('ServiceType', v)} />
          </div>
        )}
        <div className="span-2">
          <Field label="For function" type="select" value={form.FunctionId} options={functionOptions}
            onChange={(v) => setF('FunctionId', v)} />
        </div>

        <div className="span-2">
          <Field label="Company name" value={form.CompanyName} onChange={(v) => setF('CompanyName', v)} />
        </div>
        <div className="span-2">
          <Field label="Owner / contact person" value={form.ContactName} onChange={(v) => setF('ContactName', v)} />
        </div>
        <div className="span-all">
          {/* The owner is a user: pick an existing account or create one from the
              mobile number, so he can sign in and see his own work. */}
          <div style={{ display: 'flex', gap: 8, marginBottom: 6, alignItems: 'center' }}>
            <span className="muted" style={{ fontSize: 12 }}>Owner login:</span>
            <button type="button" className={`btn sm ${vendorMode === 'new' ? 'primary' : 'light'}`} onClick={() => setVendorMode('new')}>By mobile number</button>
            <button type="button" className={`btn sm ${vendorMode === 'existing' ? 'primary' : 'light'}`} onClick={() => setVendorMode('existing')}>Existing user</button>
          </div>
        </div>
        {vendorMode === 'existing' ? (
          <div className="span-2">
            <Field label="User" type="select" value={form.VendorUserId} options={userOptions} onChange={(v) => setF('VendorUserId', v)} />
          </div>
        ) : (
          <div className="span-2">
            <Field label="Owner mobile (login, PIN 1234)" value={form.ContactMobile} onChange={(v) => setF('ContactMobile', v)} />
          </div>
        )}

        <Field label="Rate type" type="select" value={form.RateType} options={RATE_TYPES} onChange={(v) => setF('RateType', v)} />
        <Field label={perUnit ? 'Rate (₹ per unit)' : 'Rate (₹)'} type="number" value={form.Rate} onChange={(v) => setF('Rate', v)} />
        {perUnit && <Field label={unitWord} type="number" value={form.ConfirmedCount} onChange={(v) => setF('ConfirmedCount', v)} />}
        <Field label="Total amount (₹)" type="number" value={form.TotalAmount} onChange={(v) => setF('TotalAmount', v)} />
        {!editing && <Field label="Advance paid now (₹)" type="number" value={form.AdvancePaid} onChange={(v) => setF('AdvancePaid', v)} />}

        <Field label="Date" type="date" required value={form.ServiceDate} onChange={(v) => setF('ServiceDate', v)} />
        <Field label="Start time" type="time" value={form.StartTime} onChange={(v) => setF('StartTime', v)} />
        <Field label="End time" type="time" value={form.EndTime} onChange={(v) => setF('EndTime', v)} />
        <Field label="Status" type="select" value={form.Status} options={SERVICE_STATUSES} onChange={(v) => setF('Status', v)} />
        <div className="span-all">
          <Field label="Notes" type="textarea" rows={2} value={form.Notes} onChange={(v) => setF('Notes', v)} />
        </div>
      </div>
      <div className="muted" style={{ fontSize: 12, marginTop: 2 }}>
        {selectedType?.ItemLabel
          ? `Save, then open the service to add its ${selectedType.ItemLabel.toLowerCase()} list and payments.`
          : 'Save, then open the service to add its items and payments.'}
      </div>
    </Modal>
  );
}
